

















































































































import BaseComponent from '@/components/base-component.vue';
import ClientUnitAddress from '@/components/client-units/client-unit-address.vue';
import ClientUnitDeliveryRoutes from '@/components/client-units/client-unit-delivery-routes.vue';
import ClientUnitDepartaments from '@/components/client-units/client-unit-departaments.vue';
import ClientUnitInsurance from '@/components/client-units/client-unit-health-insurance.vue';
import ClientUnitProducts from '@/components/client-units/client-unit-products.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { listClientUnitAddressesDetails, listClientUnitRoutesDetails } from '@/services/client-unit';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ClientUnitEnteralProducts from './client-unit-enterals.vue';
import ClientUnitMulticompart from './client-unit-multicompart.vue';
import ClientUnitPendingPrescription from './client-unit-pending-prescription.vue';
import ClientUnitTemplates from './client-unit-templates.vue';
import ClientUnitTherapies from './client-unit-therapies.vue';

@Component({
  components: {
    ClientUnitAddress,
    ClientUnitDepartaments,
    ClientUnitInsurance,
    ClientUnitProducts,
    ClientUnitDeliveryRoutes,
    ClientUnitTherapies,
    ClientUnitEnteralProducts,
    ClientUnitTemplates,
    ClientUnitMulticompart,
    ClientUnitPendingPrescription,
    PermissionAuth,
  },
})
export default class ClientUnitTab extends BaseComponent {
  @Prop()
  public item: any;

  public currentTab: string = 'tab-products';
  addresses: any[] = [];
  routes: any[] = [];

  @Watch('item.id', {immediate: true})
  public onItemChange(): void {
    this.currentTab = 'tab-products';

    this.loadAddresses();
  }

  loadAddresses() {
    if (!this.item || !this.item.id) {
      return;
    }
    listClientUnitAddressesDetails(this.item.id).subscribe(res => {
      this.addresses = res;
    }, error => {
      this.showToastApiError(error);
    });
    listClientUnitRoutesDetails(this.item.id).subscribe(res => {
      this.routes = res;
    }, error => {
      this.showToastApiError(error);
    });
  }
}
